import { getApiBaseUrl, buildUrl } from '../services/apiClient';

export { getApiBaseUrl };

export const API_BASE = getApiBaseUrl();

export const toApiUrl = (path) => buildUrl(path);
